import { createApp } from 'vue';

import Swal from 'sweetalert2';
window.Swal = Swal;

import DarkModeToggle from './components/darkModeToggle.vue';
import UsersList from './components/users/list.vue';
import WooCommerceProductsList from './components/woocommerce/products/list.vue';
import WooCommerceOrdersList from './components/woocommerce/orders/list.vue';
import PaymentsList from './components/payments/list.vue';
import PaymentAllocationsList from './components/payments/allocations/list.vue';
import CreateScheduledCommand from './components/createScheduledCommand.vue';
import ScheduledCommandsList from './components/scheduledCommands/list.vue';
import OrganisationsList from './components/organisations/list.vue';
import IplicitProductsList from './components/iplicit/products/list.vue';
import IplicitInvoicesList from './components/iplicit/invoices/list.vue';
import IplicitCreditNotesList from './components/iplicit/creditNotes/list.vue';
import ImportList from './components/import/list.vue';
import CinollaInvoicesList from './components/cinolla/invoices/list.vue';
import CinollaCreditNotesList from './components/cinolla/creditNotes/list.vue';
import CustomersList from './components/customers/list.vue';
import CentresList from './components/centres/list.vue';
import CentresConnectToCinolla from './components/centres/connectToCinolla.vue';
import CentreSyncLogsRerun from './components/centres/syncLogsRerun.vue';

const components = {
    'dark-mode-toggle': DarkModeToggle,
    'users-list': UsersList,

    'woocommerce-products-list': WooCommerceProductsList,
    'woocommerce-orders-list': WooCommerceOrdersList,
    'payments-list': PaymentsList,
    'payment-allocations-list': PaymentAllocationsList,
    'create-scheduled-command': CreateScheduledCommand,
    'centre-sync-logs-rerun': CentreSyncLogsRerun,
    'scheduled-commands-list': ScheduledCommandsList,
    'organisations-list': OrganisationsList,
    'iplicit-products-list': IplicitProductsList,
    'iplicit-invoices-list': IplicitInvoicesList,
    'iplicit-credit-notes-list': IplicitCreditNotesList,
    'import-list': ImportList,
    'cinolla-invoices-list': CinollaInvoicesList,
    'cinolla-credit-notes-list': CinollaCreditNotesList,
    'customers-list': CustomersList,
    'centres-list': CentresList,
    'centres-connect-to-cinolla': CentresConnectToCinolla,
};

let n = 0;
for (const tag in components) {
    for (const el of document.querySelectorAll(tag)) {
        const app = createApp({
            template: el.outerHTML,
            name: `${tag} ${++n}`,
        });
        app.component(tag, components[tag]);
        app.mount(el);
    }
}

window.document.querySelector('#main-container')?.addEventListener('click', (e) => {
    const button = e.target;
    if (e.target.classList.contains('js-confirmDelete')) {
        const deleteText = button.getAttribute('data-delete-text');

        confirmHandler(
            'Delete',
            deleteText,
            'Do you want to delete this?',
            'delete',
            button.getAttribute('data-delete-href'),
            'Deleted',
            button.getAttribute('data-delete-then'),
            true,
        );
    }
});

let confirmHandler = async function (confirmButton, confirmDetails, confirmQuestion, fetchAction, requestHref, successTitle, successEmit, isTable) {
    const result = await Swal.fire({
        title: confirmQuestion,
        html: confirmDetails,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: confirmButton,
        customClass: {
            confirmButton: 'bg-danger',
        },
        reverseButtons: true,
        focusConfirm: false,
    });

    if (!result.isConfirmed) {
        return;
    }

    const response = await useFetch(
        requestHref,
        {
            method: fetchAction,
        }
    )

    if (!response.ok) {
        alert('System error');
        criteria.loading = false;
    }

    const data = await response.json();

    if (data?.message.type === 'error') {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: data.message.title,
            customClass: {
                confirmButton: 'bg-danger',
            },
            showConfirmButton: true,
        });

        return;
    } else {
        Swal.fire({
            icon: 'success',
            title: successTitle,
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
        }).then(() => {
            if (isTable === false) {
                location.reload();
            } else if (successEmit) {
                Eventbus.emit(successEmit);
            }
        });
    }
};

const goToTabFromHash = function () {
    const hash = window.location.hash.split('#');
    const currentTab = document.querySelector('.nav-link[data-bs-target="#' + hash[1] + '"]');
    if (currentTab) {
        const bsTab = new bootstrap.Tab(currentTab);
        bsTab.show();
    }
};

// are we deep-linked to a tab?
if (window.location.hash) {
    goToTabFromHash();
}

let tabButtons = document.querySelectorAll('.nav-link[data-bs-target]');
if (tabButtons.length) {
    for (let tabButton of tabButtons) {
        tabButton.addEventListener('show.bs.tab', function (ev) {
            window.location.hash = ev.target.getAttribute('data-bs-target');
        });

        // don't think I like this
        // if (tabButton.classList.contains('active')) {
        //     window.location.hash = tabButton.getAttribute('data-bs-target');
        // }
    }

    window.onpopstate = goToTabFromHash;
}

import flatpickr from 'flatpickr';
flatpickr('.js-flatpickers');
